import React, { Component } from 'react'
import ThemeManager from './ThemeManager';
import i18n from "i18next";

export class MainInfo extends Component {

    constructor(props){
        super(props);
        
        this.state = { eventInfo: props.info};
        
    }


    render() {

        let themeManager = ThemeManager.getInstance();
        const _backgroundColor = themeManager.getBackgroundColor();
        const _selectionColor = themeManager.getSelectionColor();
        const _mainTextColor = themeManager.getMainTextColor();
        const _secondaryTextColor = themeManager.getSecondaryTextColor();
        const _itemBackgroundColor = themeManager.getItemBackgroundColor();
        const _errorColor = themeManager.getErrorColor();

        return (
            <div style={{marginTop: '0px'}}>


            { this.state.eventInfo.eventName !== '' &&
            <div style={{marginTop: '20px', height: '100%', marginLeft: '25px', marginRight: '25px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}> 
            <div style={{borderRadius: '8px', color: _mainTextColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>
            {this.state.eventInfo.eventName}           
            </div>        
            </div>
            }

            
            
            <div style={{marginTop: '20px'}} > </div>

            { this.state.eventInfo.clubName !== '' &&
           <div style={{marginTop: '5px', height: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}> 
           <div style={{marginTop: '3px', marginLeft: '80px',  height: '25px', borderRadius: '8px', width: '20px', color: _secondaryTextColor, fontSize: '14px', textAlign: 'left'}}>
           📍         
           </div> 
           <div style={{marginLeft: '10px',  height: '25px', borderRadius: '8px', width: '200px', color: _secondaryTextColor, fontWeight: 'normal', fontSize: '16px', textAlign: 'left'}}>
            {this.state.eventInfo.clubName}           
           </div>        
           </div>
            }


            { this.state.eventInfo.eventDate !== '' &&
            <div style={{marginTop: '5px', height: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}> 
            <div style={{marginTop: '3px', marginLeft: '80px',  height: '25px', borderRadius: '8px', width: '20px', color: _secondaryTextColor, fontSize: '12px', textAlign: 'left'}}>
            📆         
            </div> 
            <div style={{marginLeft: '10px',  height: '25px', borderRadius: '8px', width: '200px', color: _secondaryTextColor, fontWeight: 'normal', fontSize: '16px', textAlign: 'left'}}>
            {i18n.t(this.state.eventInfo.eventDateArray.day)}{this.state.eventInfo.eventDateArray.number}{i18n.t(this.state.eventInfo.eventDateArray.month)}      
            </div>        
            </div>
            }


            { this.state.eventInfo.hour !== '' &&
            <div style={{marginTop: '5px', height: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}> 
            <div style={{marginTop: '3px', marginLeft: '80px',  height: '25px', borderRadius: '8px', width: '20px', color: _secondaryTextColor, fontSize: '12px', textAlign: 'left'}}>
            🕙       
            </div> 
            <div style={{marginLeft: '10px',  height: '25px', borderRadius: '8px', width: '200px', color: _secondaryTextColor, fontWeight: 'normal', fontSize: '16px', textAlign: 'left'}}>
            {this.state.eventInfo.hour}          
            </div>        
            </div>
            }

                
            </div>
        )
    }
}

export default MainInfo
